import { createModelSchema, primitive } from 'serializr';

import { optional } from '@vromo/models';
import { observable, makeObservable } from 'mobx';


export type AccountStatusType = 'trial' | 'invoiced' | 'disabled'

export class AccountStatus {
    created: number | null = null;
    /** top level group ( vromo Account group Id) */
    group: number | null = null;
    type: AccountStatusType = 'invoiced';

    constructor() {
        makeObservable(this, {
            created: observable,
            group: observable,
            type: observable
        });
    }
}

createModelSchema(AccountStatus, {
    created: optional(primitive()),
    group: optional(primitive()),
    type: optional(primitive())
});
